import { formatUnits } from "@ethersproject/units";
import { TableCell, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import Web3 from "web3";
import createdPresaleAbi from "../../utils/createdPresaleAbi.json";

const web3 = new Web3(
  Web3.givenProvider
    ? Web3.givenProvider
    : "https://data-seed-prebsc-1-s1.binance.org:8545"
);

export default function ClosesProjectDetails({ preSaleAddress }) {
  const [presaleContract, setpresaleContract] = useState("");
  const [totalUsers, setTotalUsers] = useState(0);
  const [amountRaised, setAmountRaised] = useState(0);

  const initContracts = async () => {
    try {
      const presale = new web3.eth.Contract(createdPresaleAbi, preSaleAddress);
      setpresaleContract(presale);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (preSaleAddress) {
      initContracts();
    }
  }, [preSaleAddress]);

  const init = async () => {
    try {
      const totalRaisedAmount = await presaleContract.methods
        .amountRaised()
        .call();
      const totalUser = await presaleContract.methods.totalUser().call();
      setAmountRaised(formatUnits(totalRaisedAmount));
      setTotalUsers(totalUser);
    } catch (error) {}
  };

  useEffect(() => {
    if (presaleContract) {
      init();
    }
  }, [presaleContract]);
  const matches = useMediaQuery("(max-width:750px)");
  return (
    <>
      <TableCell
        style={{
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: 400,
          fontSize: matches ? "12px" : "15px",
          lineHeight: "18px",
          textAlign: "center",
        }}
      >
        {totalUsers}
      </TableCell>
      <TableCell
        style={{
          fontFamily: "Open Sans",
          fontStyle: "normal",
          fontWeight: 400,
          fontSize: matches ? "12px" : "15px",
          lineHeight: "18px",
          textAlign: "center",
        }}
      >
        {parseFloat(amountRaised).toFixed(2)}
      </TableCell>
    </>
  );
}
